import React, {Component} from 'react';
import Actions from '../../../actions/Actions.js';

class Remove extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.is_free = this.props.item.final_price===0;
  };

  remove = () =>{
    Actions.productUpdate({item:this.props.item,id:this.props.variant_id,quantity:0});
  };

  render() {
    return (
      <div className={"remove text-center"+(this.is_free?" invisible":"")+" "+this.props.class} onClick={()=>this.remove()}>
        Remove
      </div>
    )
  };
}
export default Remove;